import { __awaiter } from "tslib";
export default class PassThroughMapper {
    constructor() {
        this.initialized = false;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.initialized = true;
        });
    }
    set(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.initialized) {
                throw new Error("The storage mapper has not been initialized.");
            }
            return contentId;
        });
    }
    get(mapKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.initialized) {
                throw new Error("The storage mapper has not been initialized.");
            }
            return mapKey;
        });
    }
}
